import React, { useState } from 'react'
import moment from 'moment'
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import API from '../../../../services/API'

const LateStart = ({
  shiftID,
  expectedTime,
  needsLateStartReason,
  setNeedsLateStartReason,
  loadActiveShift,
}) => {
  const [reason, setReason] = useState('')
  const [otherReason, setOtherReason] = useState('')
  const expectedTimeText = moment(expectedTime).isSame(moment(), 'day')
    ? moment(expectedTime).format('HH:mm')
    : moment(expectedTime).format('DD/MM/YYYY HH:mm')

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/shift-clock-in', {
      shiftID,
      lateStartReason: reason,
    }).then((res) => {
      if (res.status === 200) {
        loadActiveShift()
        setNeedsLateStartReason(false)
      } else {
        console.log('res.data', res.data)
      }
    })
  }

  return (
    <Dialog
      open={!!needsLateStartReason}
      onClose={() => setNeedsLateStartReason(false)}
      component="form"
      onSubmit={handleSubmit}
    >
      <DialogTitle>
        <Stack gap={1}>
          <Typography variant="title3">Late Start Reason</Typography>
          <Typography variant="caption">
            Your shift was due to start at {expectedTimeText}. Please select the
            reason for the late start below.
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack gap={1}>
          <Autocomplete
            options={[
              'Forgot to Clock In',
              'Traffic / Travel Delay',
              'Vehicle Issue',
              'Previous Job Overran',
              'Delayed Handover',
              'Late Notice Booking',
              'Personal Emergency',
              'Sickness',
              'Public Transport Delay',
              'Weather Conditions',
              'IT / System Issue',
              'Uniform / Equipment Issue',
              'Other',
            ]}
            renderInput={(params) => <TextField {...params} required />}
            onChange={(e, newValue) => setReason(newValue)}
            disableClearable
          />
          {reason === 'Other' && (
            <TextField
              required
              label="Other Reason"
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => setNeedsLateStartReason(false)}
          color="error"
        >
          Cancel
        </Button>
        <Button variant="success" type="submit" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LateStart
